import {Component, Input} from '@angular/core';
import {IListUser} from '../../../../core/model/user/list-user.model';


@Component({
    selector: 'app-user-card-component',
    templateUrl: './user-card.component.html',
    styleUrls: ['./user-card.component.scss'],
    standalone: false
})
export class UserCardComponent {
  @Input() currentUsers: IListUser[];
}
